import { Component, computed, effect, inject, signal } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatError, MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { Router } from '@angular/router';
import { AuthService } from '@core/services/auth.service';
import { TranslateModule } from '@ngx-translate/core';
import { DotsSpinnerComponent } from '@shared/components/dots-spinner/dots-spinner.component';
import { IconComponent } from '@shared/components/icon/icon.component';
import { MatErrorComponent } from '@shared/components/mat-error/mat-error.component';
import { CreatePasswordStore } from './create-password.store';

@Component({
  imports: [
    DotsSpinnerComponent,
    TranslateModule,
    ReactiveFormsModule,
    MatInputModule,
    MatButtonModule,
    MatFormFieldModule,
    MatErrorComponent,
    MatError,
    IconComponent,
  ],
  providers: [CreatePasswordStore],
  selector: 'app-create-password',
  templateUrl: './create-password.component.html',
})
export class CreatePasswordComponent {
  public readonly passwordForm = new FormGroup({
    confirmPassword: new FormControl('', [Validators.required, Validators.minLength(6)]),
    password: new FormControl('', [Validators.required, Validators.minLength(6)]),
  });

  public readonly showPassword = signal(false);
  public readonly showConfirmPassword = signal(false);

  public readonly loading = computed(() => this.store.loading$() || this.waitingUserReload());

  public readonly store = inject(CreatePasswordStore);
  private readonly router = inject(Router);
  private readonly authService = inject(AuthService);

  private readonly waitingUserReload = signal(false);

  constructor() {
    effect(() => {
      if (this.store.passwordCreated$()) {
        this.waitingUserReload.set(true);
        this.authService.reloadCurrentUser().then(() => {
          this.router.navigate(['/']);
          this.waitingUserReload.set(false);
          this.store.patchState({ loading: false });
        });
      }
    });
  }

  public onSubmit(): void {
    if (this.passwordForm.invalid) {
      this.passwordForm.markAllAsTouched();

      return;
    }

    if (this.passwordForm.value.password !== this.passwordForm.value.confirmPassword) {
      this.passwordForm.get('confirmPassword')?.setErrors({ passwordsDoNotMatch: true });

      return;
    }

    this.passwordForm.get('confirmPassword')?.setErrors(null);

    this.store.createPassword({ password: this.passwordForm.value.password! });
  }
}
